import AirtableTable from "../AirtableTable";
import { Lesson } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class LessonTable extends AirtableTable<Lesson> {
  	constructor(instance: any) {
		super(instance, airtableTables.lessons);

		this.fields = [
			airtableFields.lessons.lesson, airtableFields.lessons.courses, airtableFields.lessons.units,
			airtableFields.lessons.weeks, airtableFields.lessons.resources
		]
	}

	getAll = () => {
		return this.list({
			sort: [{
			  field: airtableFields.lessons.lesson,
			  direction: "asc"
			}]
		})
	}

	getByCourse = (course: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.lessons.courses] === course));
	}

	getByUnit = (unit: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.lessons.units] === unit));
	}

	getByWeek = (week: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.lessons.weeks] === week));
	}

	getByUnitAndWeek = (unit: string, week: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.lessons.units] === unit && item[airtableFields.lessons.weeks] === week));
	}
}
